// extracted by mini-css-extract-plugin
export default {"list":"TextList_list__C4-yM"};